import { render, staticRenderFns } from "./IntervencionesDetalles.vue?vue&type=template&id=7c7d05c6&"
import script from "./IntervencionesDetalles.vue?vue&type=script&lang=js&"
export * from "./IntervencionesDetalles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports